/**
 * # Storage
 */

// Generic Active class
export const IS_ACTIVE_CLASS = 'isActive';
export const IS_FOCUS_ACTIVE_CLASS = 'isFocusActive';
export const IS_HIDDEN = 'isHidden';
export const INFO_MESSAGE_CLASS = 'siteMessage_info';
export const ALERT_MESSAGE_CLASS = 'siteMessage_alert';
export const ERROR_MESSAGE_CLASS = 'siteMessage_error';
export const SUCCESS_MESSAGE_CLASS = 'siteMessage_success';
export const LOADING_CLASS = 'loading';
export const CHECKED = 'checked';
export const TEXTCOLLAPSED = 'textCollapsed';
export const IS_ACTIVE = 'isActive';
export const INPUTERROR = 'qty-inp-err';
export const CHECKBOX = 'custom-checkbox';
export const DISABLED_CHECKBOX = 'disabled-checkbox';
export const CHECK_CART = 'js-check-cart'